var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRefuse = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.2332mm",
    height: "4.2332mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 423.32 423.32",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsXodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M8.83 9.23c5.67,-5.66 13.37,-8.84 21.37,-8.84 8.01,0 15.7,3.18 21.37,8.85l159.89 160.05 159.91 -160.05c5.69,-5.91 13.55,-9.24 21.74,-9.24 16.68,0 30.21,13.54 30.21,30.24 0,8.19 -3.33,16.05 -9.23,21.75l-159.91 160.05 159.9 160.05c5.44,5.62 8.49,13.15 8.49,20.99 0,16.7 -13.53,30.24 -30.22,30.24 -7.83,0 -15.36,-3.05 -20.98,-8.49l-159.91 -160.03 -159.91 160.04c-5.61,5.43 -13.14,8.48 -20.97,8.48 -16.68,0 -30.21,-13.54 -30.21,-30.24 0,-7.84 3.04,-15.37 8.48,-21l159.89 -160.04 -159.91 -160.04c-5.64,-5.67 -8.83,-13.37 -8.83,-21.39 0,-8.01 3.19,-15.71 8.85,-21.38l-0.02 0z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRefuse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-refuse.svg";